import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { PieChart, Pie, Cell, Sector } from 'recharts';

import { Icon, Dimmer, Image } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import { targetEmailAsyncValidate } from 'libs/validation';
import Scrollbar from 'libs/Scrollbar';
import * as common from 'libs/commonFunc';

import { DetailTemplate, MaterialSnackbar } from 'components';

import styles from './Edu.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class EduDetail extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      isSnackbar,
      // function
      onToggleSnackbar,
      onToggleDetailView,
      onMoveScroll,
      onRefRegister
    } = this.props;
    // 상세 정보
    const { eduSummaryByEduNo, selectEduNo, eduAttachData } = this.props;

    // 데이터가 없는 경우
    let isNoData = true;
    if (selectEduNo !== 'all' && eduSummaryByEduNo.size > 0) {
      isNoData = false;
    }

    let eduListComponent = '';
    let eduStatusInfo = '';
    let eduTagComponent = '';
    let eduExamComponent = [];
    const eduTagList = [];
    const eduExamList = [];
    const eduFileList = [];
    let runningTimeAll = 0;

    if (selectEduNo !== 'all') {
      const data = eduSummaryByEduNo.get(String(selectEduNo));
      const examInfo = data.get('examInfo') ? data.get('examInfo') : false;
      const fileInfo = data.get('fileInfo') ? data.get('fileInfo') : false;
      const tagInfo = data.get('eduTagData') ? data.get('eduTagData') : false;
      const quizData = data.get('quizData') ? data.get('quizData') : false;
      // 교육 현황
      const eduStatusArray = [
        // 데이터가 없을때 표시
        {
          name: '',
          color: '',
          value: data.get('eduCount') > 0 ? 0 : 100,
          status: '',
          label: '',
          percent: data.get('eduCount') > 0 ? 0 : 100,
          percentLabel: ''
        },
        {
          name: 'beforeCount',
          color: '#c8c8c8',
          value: data.get('beforeCount'),
          status: data.get('beforeCount'),
          label: defineMessages(formatMessage({ id: 'Edu_16', defaultMessage: '진행전' })),
          percent: (data.get('beforeCount') / data.get('eduCount') * 100).toFixed(0),
          percentLabel: (data.get('beforeCount') / data.get('eduCount') * 100).toFixed(0) + '%'
        },
        {
          name: 'playCount',
          color: '#ffcb2d',
          value: data.get('playCount'),
          status: data.get('playCount'),
          label: defineMessages(formatMessage({ id: 'Edu_14', defaultMessage: '진행중' })),
          percent: (data.get('playCount') / data.get('eduCount') * 100).toFixed(0),
          percentLabel: (data.get('playCount') / data.get('eduCount') * 100).toFixed(0) + '%'
        },
        {
          name: 'afterCount',
          color: '#ff6643',
          value: data.get('afterCount'),
          status: data.get('afterCount'),
          label: defineMessages(formatMessage({ id: 'Edu_15', defaultMessage: '완료' })),
          percent: (data.get('afterCount') / data.get('eduCount') * 100).toFixed(0),
          percentLabel: (data.get('afterCount') / data.get('eduCount') * 100).toFixed(0) + '%'
        }
      ];

      // 교육현황
      eduStatusInfo = (
        <div className={cx('infectFile-area')}>
          <div className={cx('infectFile-item')}>
            <div>
              <PieChart width={120} height={120}>
                <Pie
                  dataKey="value"
                  data={[
                    {
                      name: 'background',
                      value: 100
                    }
                  ]}
                  cx={55}
                  cy={55}
                  paddingAngle={0}
                  innerRadius={20}
                  outerRadius={55}>
                  <Cell fill="#f7f7f7" />
                </Pie>
                <Pie
                  dataKey="value"
                  data={eduStatusArray}
                  cx={55}
                  cy={55}
                  innerRadius={25}
                  outerRadius={50}
                  startAngle={450}
                  endAngle={90}
                  paddingAngle={-1}
                  activeIndex={0}
                  activeShape={e => {
                    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = e;
                    return (
                      <g>
                        {/* 그라데이션 효과 */}
                        {/* 진행전 */}
                        <defs>
                          <linearGradient id="c8c8c8" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#e3e3e3" />
                            <stop offset="50%" stopColor="#e3e3e3" />
                            <stop offset="100%" stopColor="#bababa" />
                          </linearGradient>
                        </defs>
                        {/* 진행중 */}
                        <defs>
                          <linearGradient id="ffcb2d" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#f2af0e" />
                            <stop offset="50%" stopColor="#f2af0e" />
                            <stop offset="100%" stopColor="#ff6643" />
                          </linearGradient>
                        </defs>
                        {/* 완료 */}
                        <defs>
                          <linearGradient id="ff6643" x1="0" y1="0" x2="0" y2="1">
                            {/* <stop offset="0%" stopColor="#f2af0e" />
                            <stop offset="100%" stopColor="#ffcb2d" /> */}
                            <stop offset="0%" stopColor="#e14b16" />
                            <stop offset="50%" stopColor="#e14b16" />
                            <stop offset="100%" stopColor="#ff6643" />
                          </linearGradient>
                        </defs>

                        {/* 차트의 기본 형태 영역 */}
                        <Sector
                          cx={cx}
                          cy={cy}
                          innerRadius={innerRadius}
                          outerRadius={outerRadius}
                          startAngle={startAngle}
                          endAngle={endAngle}
                          fill={fill}
                        />
                        {/* 차트의 확장 처리 */}
                        <Sector
                          cx={cx}
                          cy={cy}
                          startAngle={startAngle}
                          endAngle={endAngle}
                          innerRadius={outerRadius - 1}
                          outerRadius={outerRadius + 8}
                          fill={fill}
                        />
                      </g>
                    );
                  }}>
                  {/* cell 안에 퍼센트 표시 */}
                  {eduStatusArray.map((entry, index) => <Cell key={index} fill={'url(' + entry.color + ')'} />)}
                </Pie>
              </PieChart>
            </div>
            <div className={cx('examDetail-infectionFile')}>
              <span className={cx('examDetail-legend')}>
                <div className={cx('examInfo')}>
                  <span className={cx('examInfo-title')}>
                    <strong>{defineMessages(formatMessage({ id: 'Edu_45', defaultMessage: '총 대상자' }))}</strong>
                  </span>
                  <span className={cx('examInfo-content')}>
                    <strong>
                      {data.get('eduCount')}
                      {defineMessages(formatMessage({ id: 'Edu_39', defaultMessage: '명' }))}
                    </strong>
                  </span>
                </div>
                {eduStatusArray.map(
                  (entry, index) =>
                    !!entry.name && (
                      <div className={cx('examInfo')} key={index}>
                        <span className={cx('examInfo-title')}>
                          <Icon name="circle" style={{ color: entry.color }} />
                          {entry.label}
                        </span>
                        <span className={cx('examInfo-content')}>
                          {entry.value}
                          {defineMessages(formatMessage({ id: 'Edu_39', defaultMessage: '명' })) +
                            ' (' +
                            entry.percentLabel +
                            ')'}
                        </span>
                      </div>
                    )
                )}
              </span>
            </div>
          </div>
        </div>
      );

      // 교육 컨텐츠 - 서브 타이틀
      if (!!fileInfo) {
        fileInfo.map((fileData, index) => {
          // 전체 컨텐츠 시간
          runningTimeAll = runningTimeAll + fileData.get('runningTime');

          const fileQuizList = [];
          if (quizData) {
            // 관련 퀴즈
            const fileQuiz = quizData.filter(quizEle => {
              return quizEle.get('fileNo') === fileData.get('fileNo');
            });
            fileQuiz.map((quizData, index) => {
              fileQuizList.push(
                <div className={'quiz-content'} key={index}>Q{index + 1}. {quizData.get('quizContent')}</div>
              );
            });
          }

          eduFileList.push(
            <div key={index}>
              {index + 1}.&nbsp;&nbsp;{fileData.get('fileName')}{' '}
              <span className={cx('edu-running-time')}>
                ({common.timeDiffFromSeconds(fileData.get('runningTime'))})
              </span>
              {fileQuizList}
            </div>
          );
        });
      }

      // 교육 정보
      eduListComponent = (
        <div className={cx('segment-content')}>
          <div className={cx('targetStatus')}>
            <div className={cx('targetStatus-title')}>No</div>
            <div className={cx('targetStatus-content')}>{data.get('eduNo')}</div>
          </div>
          <div className={cx('targetStatus')}>
            <div className={cx('targetStatus-title')}>
              {defineMessages(formatMessage({ id: 'Edu_1', defaultMessage: '교육명' }))}
            </div>
            <div className={cx('targetStatus-content')}>{data.get('eduName')}</div>
          </div>
          <div className={cx('targetStatus')}>
            <div className={cx('targetStatus-title')}>
              {defineMessages(formatMessage({ id: 'Edu_2', defaultMessage: '교육 기간' }))}
            </div>
            <div className={cx('targetStatus-content')}>
              {common.timeFormatFromUTCEpoch(data.get('startEpoch'), 3) +
                ' ~ ' +
                common.timeFormatFromUTCEpoch(data.get('endEpoch'), 3)}
            </div>
          </div>
          <div className={cx('targetStatus', 'sub-content')}>
            <div className={cx('targetStatus-title')}>
              {defineMessages(formatMessage({ id: 'Edu_8', defaultMessage: '컨텐츠' }))}
            </div>
            <div className={cx('edu-content-info')}>
              <div className={cx('content-title')}>
                {data.get('attachName')}
                <span className={cx('edu-running-time')}>{'(' + common.timeDiffFromSeconds(runningTimeAll) + ')'}</span>
              </div>
              {/* <div className={cx('targetStatus-content', 'sub-info')}>{data.get('attachContent')}</div> */}
              <div className={cx('content-sub-title')}>{eduFileList}</div>
              <div className={cx('edu-thumbnail')}>
                {!!data && data.get('thumbNail') ? (
                  <Image src={data.get('thumbNail')} />
                ) : (
                    <Image src="/img/edu/thumbnail_noimg.png" />
                  )}
                <div className={cx('edu-thumbnail-wrap')}>
                  <Image src="/img/edu/thumbnail_wrap.png" />
                </div>
              </div>
            </div>
          </div>
          <div className={cx('targetStatus', 'sub-content')}>
            <div className={cx('targetStatus-title')}>
              {defineMessages(formatMessage({ id: 'Edu_46', defaultMessage: '교육현황' }))}
            </div>
            <div className={cx('edu-content-info')}>
              <div className={cx('targetStatus-content')}>{eduStatusInfo}</div>
            </div>
          </div>
          <div className={cx('targetStatus')}>
            <div className={cx('targetStatus-title')}>
              {defineMessages(formatMessage({ id: 'Edu_47', defaultMessage: '등록일시' }))}
            </div>
            <div className={cx('targetStatus-content')}>{common.timeFormatFromUTCEpoch(data.get('regEpoch'))}</div>
          </div>
        </div>
      );

      // 태그
      if (!!tagInfo) {
        tagInfo.map((tagData, index) => {
          const tagColor = 'tag-label-' + tagData.get('color');

          eduTagList.push(
            <div key={index}>
              <span className={cx('edu-tag-item', tagColor)}>{tagData.get('tagName')}</span>
            </div>
          );
        });
      }
      eduTagComponent = <div className={cx('segment-content', 'edu-list')}>{eduTagList}</div>;

      // 훈련
      if (!!examInfo) {
        examInfo.map((examData, index) => {
          eduExamList.push(
            <div key={index} className={cx('edu-exam-item')}>
              <div className={cx('examTitle')}>·&nbsp;&nbsp;{examData.get('examName')}</div>
              <span className={cx('examDate')}>
                {defineMessages(formatMessage({ id: 'Edu_48', defaultMessage: '훈련 기간' }))}
                {common.timeFormatFromUTCEpoch(examData.get('startEpoch'), 3) +
                  ' ~ ' +
                  common.timeFormatFromUTCEpoch(examData.get('endEpoch'), 3)}
              </span>
            </div>
          );
        });
      }
      eduExamComponent = (
        <div className={cx('segment-content', 'edu-exam-list')}>
          {!!eduExamList && eduExamList.length > 0 ? (
            eduExamList
          ) : (
              <div className={cx('brand-green')}>
                <Icon name="checkmark box" />
                {defineMessages(formatMessage({ id: 'Edu_49', defaultMessage: '연결 된 훈련 없음' }))}
              </div>
            )}
        </div>
      );
    }

    return (
      <DetailTemplate onMoveScroll={onMoveScroll} onToggleDetailView={onToggleDetailView}>
        <MaterialSnackbar isSnackbar={isSnackbar} onToggleSnackbar={onToggleSnackbar} />
        {/* ------------------------------------- 데이터가 없을 경우 ------------------------------------ */}
        {!!isNoData && (
          <Dimmer active inverted className={cx('isNoData')}>
            <div className={cx('isNoData-content')}>
              {/* <Icon name="pointing up" /> */}
              <Image className={cx('mr-5 info-select-icon')} src="/img/exam/info_select.png" />
              <div className={cx('text')}>
                {defineMessages(formatMessage({ id: 'Edu_50', defaultMessage: '교육을 선택하세요' }))}
              </div>
            </div>
          </Dimmer>
        )}
        <Scrollbar
          ref={Scroll => {
            onRefRegister('scroll', Scroll);
          }}>
          <div className={cx('element-wrapper', 'edu-detail-wrapper')}>
            <div className={cx('')}>
              {/* <div className={cx('exam-title')}></div> */}
              {/* 신고 상세 리스트 */}
              {!!!isNoData &&
                !!eduListComponent && (
                  <div>
                    <div className={cx('element')}>
                      <div className={cx('segment-title')}>
                        <span className={cx('toggle-title bold')}>
                          {defineMessages(formatMessage({ id: 'Edu_51', defaultMessage: '교육 정보' }))}
                        </span>
                      </div>
                      <div className={cx('segment-content', 'tag-content', 'target-tags')}>{eduListComponent}</div>
                    </div>
                    <div className={cx('element')}>
                      <div className={cx('segment-title')}>
                        <span className={cx('toggle-title bold')}>
                          {defineMessages(formatMessage({ id: 'Edu_52', defaultMessage: '태그' }))}
                        </span>
                      </div>
                      <div className={cx('segment-content', 'tag-content', 'target-tags')}>{eduTagComponent}</div>
                    </div>
                    <div className={cx('element')}>
                      <div className={cx('segment-title')}>
                        <span className={cx('toggle-title bold')}>
                          {defineMessages(formatMessage({ id: 'Edu_53', defaultMessage: '훈련' }))}
                        </span>
                      </div>
                      <div className={cx('segment-content', 'tag-content', 'target-tags')}>{eduExamComponent}</div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </Scrollbar>
      </DetailTemplate>
    );
  }
}

EduDetail.propTypes = {
  onToggleModal: PropTypes.func
};

const mapStateToProps = state => {
  return {
    initialValues: {
      //
    }
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formTargetEdit',
    enableReinitialize: true,
    asyncValidate: targetEmailAsyncValidate,
    asyncBlurFields: ['targetEmail'],
    destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
  })(injectIntl(EduDetail))
);



// WEBPACK FOOTER //
// ./src/script/components/edu/EduDetail.js